'use client'

import { useTranslations } from 'next-intl'
import { SaveIcon, XIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

type PropsType = {
  isDirty: boolean
  isSaving?: boolean
  onSave: () => void
  onDiscard: () => void
}

export default function StickyBottomSaveBar({ isDirty, isSaving = false, onSave, onDiscard }: PropsType) {
  const t = useTranslations()

  if (!isDirty) {
    return null
  }

  return (
    <div className="bg-background/95 sticky bottom-0 z-40 -mx-6 -mb-6 border-t px-6 py-3 shadow-lg backdrop-blur">
      <div className="flex items-center justify-between gap-4">
        <span className="text-sm font-medium">{t('unsaved_changes')}</span>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={onDiscard} disabled={isSaving}>
            <XIcon className="h-4 w-4" />
            {t('discard')}
          </Button>
          <Button size="sm" onClick={onSave} disabled={isSaving}>
            <SaveIcon className="h-4 w-4" />
            {isSaving ? t('saving') : t('save_changes')}
          </Button>
        </div>
      </div>
    </div>
  )
}
